import styles from '@styles/CrudProduct.module.css'
import useFormatPrice from '@hooks/useFormatPrice'
import OfferTable from '@components/OfferTable'
import OfferForm from '@components/OfferForm'
import { Navigate } from 'react-router-dom'
import { useOffer } from '@hooks/useOffer'
import Loading from '@components/Loading'
import useAuth from '@hooks/useAuth'
import PropTypes from 'prop-types'
import { useState } from 'react'

const AdminOffers = ({ darkMode = false }) => {
  const { offers, error, addOffer, editOffer, removeOffer, toggleStatus } = useOffer()
  const [editingOffer, setEditingOffer] = useState(null)
  const { user, loading: authLoading } = useAuth()
  const formatPrice = useFormatPrice()

  if (authLoading) return <Loading />
  if (!user) return <Navigate to='/login' />
  if (error) return <div>Error: {error}</div>

  const handleCreateOffer = async (newOffer) => {
    await addOffer(newOffer)
  }

  const handleUpdateOffer = async (updatedOffer) => {
    await editOffer(updatedOffer.id, updatedOffer)
    setEditingOffer(null)
  }

  const handleDeleteOffer = async (id) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta oferta?')) {
      await removeOffer(id)
    }
  }

  const handleToggleStatus = async (id, currentStatus) => {
    await toggleStatus(id, currentStatus)
  }

  return (
    <div className={`${styles.container} ${darkMode ? styles.dark : ''}`}>
      <h1 className={styles.title}>Gestionar Ofertas</h1>

      <OfferForm
      onSubmit={handleCreateOffer}
      darkMode={darkMode}
      />

      <OfferTable
        offers={offers}
        onDelete={handleDeleteOffer}
        onEdit={setEditingOffer}
        onToggleStatus={handleToggleStatus}
        formatPrice={formatPrice}
        darkMode={darkMode}
      />

      {editingOffer && (
        <div className={styles.overlay}>
          <div className={styles.editCard}>
            <button
              onClick={() => setEditingOffer(null)}
              className={styles.closeButton}
            >
              x
            </button>
            <OfferForm
              offer={editingOffer}
              onSubmit={handleUpdateOffer}
              darkMode={darkMode}
              isEditing={true}
            />
          </div>
        </div>
      )}
    </div>
  )
}

AdminOffers.propTypes = {
  darkMode: PropTypes.bool,
}

export default AdminOffers
